<script setup lang="ts">
  import { type HTMLAttributes, computed } from 'vue'
  import { Search } from 'lucide-vue-next'
  import { ComboboxInput, type ComboboxInputProps, useForwardProps } from 'radix-vue'
  import { cn } from '@/lib/utils'

  defineOptions({
    inheritAttrs: false
  })

  const props = defineProps<
    ComboboxInputProps & {
      class?: HTMLAttributes['class']
      modelValue?: string
    }
  >()

  const emit = defineEmits<{
    'update:modelValue': [value: string]
  }>()

  const delegatedProps = computed(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { class: _, modelValue, ...delegated } = props

    return delegated
  })

  const forwardedProps = useForwardProps(delegatedProps)

  const onInput = (e: any) => {
    emit('update:modelValue', e.target.value)
  }
</script>

<template>
  <div
    class="flex items-center border-b px-3"
    cmdk-input-wrapper
  >
    <Search class="mr-2 h-4 w-4 shrink-0 opacity-50" />
    <ComboboxInput
      v-bind="{ ...forwardedProps, ...$attrs }"
      auto-focus
      :value="modelValue"
      :class="
        cn(
          `flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none
          placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50`,
          props.class
        )
      "
      @input="onInput"
    />
  </div>
</template>
